<template>
  <el-dialog
    title="单位编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
import { queryUnit } from '@/api/unitrental'

export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '租赁单位',
          field: 'unitName',
          type: 'text',
          // width: '180px',
          rules: [{ required: true, message: '单位名称必填', trigger: 'blur' }]
        },
        {
          label: '租赁单位关联单位',
          field: 'inspectUnitDevices',
          type: 'select',
          // width: '180px',
          multiple: true,
          filterable: true,
          payload: [],
          rules: [{ required: true, message: '关联单位必选', trigger: 'blur' }]
        }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  created() {
    this.queryUnitFn()
  },
  methods: {
    //租赁单位字典
    queryUnitFn() {
      var data = {}
      queryUnit(data).then((res) => {
        console.log(res.data, '租赁单位')
        this.formConfig[1].payload = res.data
      })
    },
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
